import { render, staticRenderFns } from "./HKbusinessKYCInfo.vue?vue&type=template&id=164b4c8e&scoped=true"
import script from "./HKbusinessKYCInfo.vue?vue&type=script&lang=js"
export * from "./HKbusinessKYCInfo.vue?vue&type=script&lang=js"
import style0 from "./HKbusinessKYCInfo.vue?vue&type=style&index=0&id=164b4c8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b4c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164b4c8e')) {
      api.createRecord('164b4c8e', component.options)
    } else {
      api.reload('164b4c8e', component.options)
    }
    module.hot.accept("./HKbusinessKYCInfo.vue?vue&type=template&id=164b4c8e&scoped=true", function () {
      api.rerender('164b4c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/businessKYC/components/HKbusinessKYCInfo.vue"
export default component.exports